import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import ChatList from "../../chat/ChatList";
import { loadDrivers } from "../../../state/driver/driverAction";

class SiderbarRight extends Component {
  static propTypes = {
    token: PropTypes.string.isRequired,
    drivers: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number })),
    dispatch: PropTypes.func.isRequired,
    handleDriverClicked: PropTypes.func,
    onDriverClick: PropTypes.func,
    centerOnMapOnly: PropTypes.bool
  };

  static defaultProps = {
    drivers: []
  };

  constructor(props) {
    super(props);
    this.init = false;
  }

  componentDidMount() {
    this.updateDrivers({
      filterTags: null
    });
  }

  updateDrivers(filter) {
    const { token, dispatch } = this.props;
    // load drivers
    dispatch(loadDrivers(token, filter));
  }

  render() {
    const { drivers, handleDriverClicked, onDriverClick, centerOnMapOnly } =
      this.props;

    return (
      <ChatList
        drivers={drivers}
        handleDriverClicked={handleDriverClicked}
        onDriverClick={onDriverClick}
        centerOnMapOnly={centerOnMapOnly}
      />
    );
  }
}

const mapStateToProps = ({ auth, driver }) => ({
  token: auth.token,
  drivers: driver.drivers
});

export default connect(mapStateToProps)(SiderbarRight);
